<template>

        <v-select
                prepend-icon="label"
                :items="items"
                :item-text="'nombre'"
                :item-value="'id'"
                v-model="item"
                :label="$t('modelo.labels.marca')"
                :loading="loading"
                :disabled="disabled"
                :error="hasInputErrors('marca')"
                :error-messages="getInputErrors('marca')"
                color="secondary"
                item-color="secondary"
                :rules="disabled ? [] : required"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    
    
    import MarcaProvider from "../../../../marca/providers/MarcaProvider"

    export default {
        name: "MarcaCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {
               type: [String, Array]
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                items: [],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        mounted() {
         this.fetch()
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            fetch(){
               this.loading= true
                MarcaProvider.fetchMarcas().then(r => {
                    this.items = r.data.marcaFetch
                }).catch(err => console.error(err))
                .finally(()=> this.loading = false)
            }
            
        }
    }
</script>

<style scoped>

</style>

